import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import {AnchorConfig} from '../../entities/anchor-config';

@Component({
  selector: 'app-s-anchor',
  templateUrl: './s-anchor.component.html',
  styleUrls: ['./s-anchor.component.less']
})
export class SAnchorComponent implements OnInit {
  @Input() anchorConfig: AnchorConfig;
  @Input() el: string | HTMLElement;

  @Output() scrollToElement: EventEmitter<any> =  new EventEmitter();
  
  constructor() {
  }

  ngOnInit(): void {
    const timer = setInterval(_ => {
      if (!this.el) {
        this.el = document.querySelector('.formWrap') as HTMLElement;
      } else {
        clearInterval(timer);
      }
    }, 300);
  }

  scrollTo(item, index) {
    this.anchorConfig.data.forEach((e) => {
      e.active = false;
      if (e.href === item.href) {
        e.active = true;
        item.active = true;
      }
    });
    this.scrollToElement.emit({href: item.href, index});
  }
}
